var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild, ElementRef, HostListener, ViewChildren, ChangeDetectorRef, QueryList, Input, Output, EventEmitter } from "@angular/core";
import { Http } from "@angular/http";
import { ImageService } from "../services/image.service";
export var GalleryComponent = (function () {
    function GalleryComponent(ImageService, http, ChangeDetectorRef) {
        this.ImageService = ImageService;
        this.http = http;
        this.ChangeDetectorRef = ChangeDetectorRef;
        this.providedImageMargin = 3;
        this.providedImageSize = 7;
        this.providedGalleryName = '';
        this.viewerChange = new EventEmitter();
        this.imageDataFilePath = 'assets/img/gallery/';
        this.dataFileName = 'data.json';
        this.images = [];
        this.gallery = [];
        this.minimalQualityCategory = 'preview_xxs';
    }
    GalleryComponent.prototype.triggerCycle = function (event) {
        this.scaleGallery();
    };
    GalleryComponent.prototype.windowResize = function (event) {
        this.render();
    };
    GalleryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fetchDataAndRender();
        this.viewerSubscription = this.ImageService.showImageViewerChanged$
            .subscribe(function (visibility) { return _this.viewerChange.emit(visibility); });
    };
    GalleryComponent.prototype.ngOnChanges = function (changes) {
        // input params changed
        this.render();
    };
    GalleryComponent.prototype.ngOnDestroy = function () {
        if (this.viewerSubscription) {
            this.viewerSubscription.unsubscribe();
        }
    };
    GalleryComponent.prototype.openImageViewer = function (img) {
        this.ImageService.updateSelectedImageIndex(this.images.indexOf(img));
        this.ImageService.showImageViewer(true);
    };
    GalleryComponent.prototype.fetchDataAndRender = function () {
        var _this = this;
        this.imageDataFilePath = this.providedGalleryName != '' ?
            this.imageDataFilePath + this.providedGalleryName + '/' + this.dataFileName :
            this.imageDataFilePath + this.dataFileName;
        this.http.get(this.imageDataFilePath)
            .map(function (res) { return res.json(); })
            .subscribe(function (data) {
            _this.images = data;
            _this.ImageService.updateImages(_this.images);
            _this.images.forEach(function (image) {
                image['galleryImageLoaded'] = false;
                image['viewerImageLoaded'] = false;
                image['srcAfterFocus'] = '';
            });
            // twice, single leads to different strange browser behaviour
            _this.render();
            _this.render();
        }, function (err) { return console.error("Did you run the convert script from angular2-image-gallery for your images first? Original error: " + err); }, function () { return undefined; });
    };
    GalleryComponent.prototype.render = function () {
        this.gallery = [];
        var tempRow = [this.images[0]];
        var rowIndex = 0;
        var i = 0;
        for (i; i < this.images.length; i++) {
            while (this.images[i + 1] && this.shouldAddCandidate(tempRow, this.images[i + 1])) {
                i++;
            }
            if (this.images[i + 1]) {
                tempRow.pop();
            }
            this.gallery[rowIndex++] = tempRow;
            tempRow = [this.images[i + 1]];
        }
        this.scaleGallery();
    };
    GalleryComponent.prototype.shouldAddCandidate = function (imgRow, candidate) {
        var oldDifference = this.calcIdealHeight() - this.calcRowHeight(imgRow);
        imgRow.push(candidate);
        var newDifference = this.calcIdealHeight() - this.calcRowHeight(imgRow);
        return Math.abs(oldDifference) > Math.abs(newDifference);
    };
    GalleryComponent.prototype.calcRowHeight = function (imgRow) {
        var originalRowWidth = this.calcOriginalRowWidth(imgRow);
        var ratio = (this.getGalleryWidth() - (imgRow.length - 1) * this.calcImageMargin()) / originalRowWidth;
        var rowHeight = imgRow[0][this.minimalQualityCategory]['height'] * ratio;
        return rowHeight;
    };
    GalleryComponent.prototype.calcImageMargin = function () {
        var galleryWidth = this.getGalleryWidth();
        var ratio = galleryWidth / 1920;
        return Math.round(Math.max(1, this.providedImageMargin * ratio));
    };
    GalleryComponent.prototype.calcOriginalRowWidth = function (imgRow) {
        var _this = this;
        var originalRowWidth = 0;
        imgRow.forEach(function (img) {
            var individualRatio = _this.calcIdealHeight() / img[_this.minimalQualityCategory]['height'];
            img[_this.minimalQualityCategory]['width'] = img[_this.minimalQualityCategory]['width'] * individualRatio;
            img[_this.minimalQualityCategory]['height'] = _this.calcIdealHeight();
            originalRowWidth += img[_this.minimalQualityCategory]['width'];
        });
        return originalRowWidth;
    };
    GalleryComponent.prototype.calcIdealHeight = function () {
        return this.getGalleryWidth() / (80 / this.providedImageSize) + 100;
    };
    GalleryComponent.prototype.getGalleryWidth = function () {
        if (this.galleryContainer.nativeElement.clientWidth === 0) {
            // IE11
            return this.galleryContainer.nativeElement.scrollWidth;
        }
        return this.galleryContainer.nativeElement.clientWidth;
    };
    GalleryComponent.prototype.scaleGallery = function () {
        var _this = this;
        var imageCounter = 0;
        var maximumGalleryImageHeight = 0;
        this.gallery.forEach(function (imgRow) {
            var originalRowWidth = _this.calcOriginalRowWidth(imgRow);
            if (imgRow !== _this.gallery[_this.gallery.length - 1]) {
                var ratio_1 = (_this.getGalleryWidth() - (imgRow.length - 1) * _this.calcImageMargin()) / originalRowWidth;
                imgRow.forEach(function (img) {
                    img['width'] = img[_this.minimalQualityCategory]['width'] * ratio_1;
                    img['height'] = img[_this.minimalQualityCategory]['height'] * ratio_1;
                    maximumGalleryImageHeight = Math.max(maximumGalleryImageHeight, img['height']);
                    _this.checkForAsyncLoading(img, imageCounter++);
                });
            }
            else {
                imgRow.forEach(function (img) {
                    img.width = img[_this.minimalQualityCategory]['width'];
                    img.height = img[_this.minimalQualityCategory]['height'];
                    maximumGalleryImageHeight = Math.max(maximumGalleryImageHeight, img['height']);
                    _this.checkForAsyncLoading(img, imageCounter++);
                });
            }
        });
        if (maximumGalleryImageHeight > 375) {
            this.minimalQualityCategory = 'preview_xs';
        }
        else {
            this.minimalQualityCategory = 'preview_xxs';
        }
        this.ChangeDetectorRef.detectChanges();
    };
    GalleryComponent.prototype.checkForAsyncLoading = function (image, imageCounter) {
        var imageElements = this.imageElements.toArray();
        if (image['galleryImageLoaded'] ||
            (imageElements.length > 0 && this.isScrolledIntoView(imageElements[imageCounter].nativeElement))) {
            image['galleryImageLoaded'] = true;
            image['srcAfterFocus'] = image[this.minimalQualityCategory]['path'];
        }
        else {
            image['srcAfterFocus'] = '';
        }
    };
    GalleryComponent.prototype.isScrolledIntoView = function (element) {
        var elementTop = element.getBoundingClientRect().top;
        var elementBottom = element.getBoundingClientRect().bottom;
        return elementTop < window.innerHeight && elementBottom >= 0 && (elementBottom > 0 || elementTop > 0);
    };
    __decorate([
        Input('flexBorderSize'), 
        __metadata('design:type', Number)
    ], GalleryComponent.prototype, "providedImageMargin", void 0);
    __decorate([
        Input('flexImageSize'), 
        __metadata('design:type', Number)
    ], GalleryComponent.prototype, "providedImageSize", void 0);
    __decorate([
        Input('galleryName'), 
        __metadata('design:type', String)
    ], GalleryComponent.prototype, "providedGalleryName", void 0);
    __decorate([
        Output(), 
        __metadata('design:type', Object)
    ], GalleryComponent.prototype, "viewerChange", void 0);
    __decorate([
        ViewChild('galleryContainer'), 
        __metadata('design:type', ElementRef)
    ], GalleryComponent.prototype, "galleryContainer", void 0);
    __decorate([
        ViewChildren('imageElement'), 
        __metadata('design:type', QueryList)
    ], GalleryComponent.prototype, "imageElements", void 0);
    __decorate([
        HostListener('window:scroll', ['$event']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [Object]), 
        __metadata('design:returntype', void 0)
    ], GalleryComponent.prototype, "triggerCycle", null);
    __decorate([
        HostListener('window:resize', ['$event']), 
        __metadata('design:type', Function), 
        __metadata('design:paramtypes', [Object]), 
        __metadata('design:returntype', void 0)
    ], GalleryComponent.prototype, "windowResize", null);
    GalleryComponent = __decorate([
        Component({
            selector: 'gallery',
            template: '<div #galleryContainer class="galleryContainer"><div class="innerGalleryContainer"><div *ngFor="let imgrow of gallery; let i = index" class="imagerow" [style.margin-bottom.px]="calcImageMargin()"><img #imageElement *ngFor="let img of imgrow; let j = index" class="thumbnail" [style.width.px]="img[\'width\']" [style.height.px]="img[\'height\']" (click)="openImageViewer(img)" [src]="img[\'srcAfterFocus\']" [style.background]="img.dominantColor" [style.margin-right.px]="calcImageMargin()"></div></div></div><viewer></viewer>',
            styles: ['.innerGalleryContainer{position:relative}.galleryContainer{height:100%;width:100%;overflow:hidden}.galleryContainer img:last-child{margin-right:-1px!important}.galleryContainer img:hover{-webkit-filter:brightness(50%);filter:brightness(50%);transition:all ease-out .2s;cursor:pointer}.imagerow{margin-right:1px;overflow:hidden;display:flex}::-webkit-scrollbar{display:none}.asyncLoadingContainer{position:absolute;background-color:transparent;height:0;width:0;bottom:120px}']
        }), 
        __metadata('design:paramtypes', [ImageService, Http, ChangeDetectorRef])
    ], GalleryComponent);
    return GalleryComponent;
}());
//# sourceMappingURL=c:/dev/ng2imggallery/src/app/gallery/gallery.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-image-gallery/app/gallery/gallery.component.js
// module id = 681
// module chunks = 3